import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { IGenericEntry } from 'src/app/classes/def/app/entry';


@Component({
  selector: 'card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss'],
})
export class CardItemComponent implements OnInit, OnDestroy, OnChanges {
  descriptionHtml: string;

  @Input()
  data: IGenericEntry;

  @Input()
  small: boolean;

  @Input()
  heading: boolean;

  @Input()
  reload: boolean;

  @Output()
  action: EventEmitter<IGenericEntry> = new EventEmitter();

  isLoading: boolean = false;
  itemName: string = "";
  isLocked: boolean = false;

  constructor(

  ) { }

  ngOnChanges(changes: SimpleChanges) {
    let keys: string[] = Object.keys(changes);
    for (let i = 0; i < keys.length; i++) {
      const chg: SimpleChange = changes[keys[i]];
      if (!chg.isFirstChange()) {
        switch (keys[i]) {
          case 'data':
          case 'reload':
            console.log("reload specs: ", this.data);
            this.reloadSpecs();
            break;
          default:
            break;
        }
      }
    }
  }

  ngOnInit() {
    if (this.data) {
      console.log("card item: ", this.data);
      this.reloadSpecs();
    }
  }

  reloadSpecs() {
    this.descriptionHtml = this.data.description;
    this.itemName = this.data.name;
  }

  ngOnDestroy() {

  }

  onTapSelect() {
    this.action.emit(this.data);
  }
}

